'use strict';

function CompanyPublicationEditFileContentDirective(
  CompanyPublicationFileService,
  $stateParams,
  $translate,
  config,
  growl) {
  return {
    restrict: 'AE',
    scope: {
      currentFile: '='
    },
    link: function(scope) {
      scope.formDisabled = true;
      scope.contentLoading = false;
      scope.toggleEdit = function() {
        scope.contentLoading = true;
        CompanyPublicationFileService.fileContent({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          fileId: scope.currentFile.id
        }, function(resp){
          scope.formDisabled = !scope.formDisabled;
          scope.contentLoading = true;
          scope.origContent = angular.copy(resp);
          scope.fileContent = angular.copy(resp);
        });
      };

      scope.save = function() {
        scope.contentLoading = false;
        scope.fileContent.$updateFileContent({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          fileId: scope.currentFile.id
        }, function(){
          growl.addSuccessMessage($translate.instant('publication.file-content.update-success'));
          scope.origContent = angular.copy(scope.fileContent);
          scope.currentFile.originalFilename = scope.fileContent.originalFilename;
          scope.formDisabled = true;
        }, function(){
          growl.addErrorMessage($translate.instant('publication.file-content.update-failure'));
        });
      };

      scope.cancel = function() {
        scope.contentLoading = false;
        scope.fileContent = angular.copy(scope.origContent);
        scope.currentFile.originalFilename = scope.origContent.originalFilename;
      };

      scope.toggleActive = function() {
        scope.currentFile.searchAble = !scope.currentFile.searchAble;
        CompanyPublicationFileService.updateSearchable({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId,
          fileId: scope.currentFile.id
        }, {searchAble: scope.currentFile.searchAble}, function(){
          growl.addSuccessMessage($translate.instant('publication.file-content.update-success'));
        }, function(){
          growl.addErrorMessage($translate.instant('publication.file-content.update-failure'));
        });
      };

      scope.download = function(file) {
        CompanyPublicationFileService.getFileToken({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, fileId: file.id}, {}, function(response) {
          var additionParams = "";
          // additionParams = '&currentUserId=' + $scope.currentUser.id;
          var elm = angular.element(document.querySelector('body'));
          var iFrame = elm.find('#downloadWindow');
          if (!(iFrame && iFrame.length > 0)) {
            iFrame = angular.element("<iframe id='downloadWindow' style='position:fixed;display:none;top:-1px;left:-1px;'/>");
            elm.append(iFrame);
          }

          iFrame.attr('src', config.apiBase + '/companies/' + $stateParams.companyId + '/publications/' + $stateParams.publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams);
          var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
          if (true === iOS) {
            window.open(config.apiBase + '/companies/' + $stateParams.companyId + '/publications/' + $stateParams.publicationId + '/files/' + file.id + '/raw?token=' + response.token + '&download=true' + additionParams, '_self');
            return;
          }
        });
      };
    },
    templateUrl: 'partials/company/publications/detail/edit-file-content.html'
  };

}

angular.module('dokiv')
  .directive('publicationEditFileContent', [
    'CompanyPublicationFileService',
    '$stateParams',
    '$translate',
    'config',
    'growl',
    CompanyPublicationEditFileContentDirective]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationEditFileContentDirective.js
// module id = 375
// module chunks = 0